import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import { fmtDate } from "../lib/utils-app";
import Seo, { ld } from "../components/Seo";

export default function Author() {
  const { slug } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/authors/${slug}`).then((r) => {
      setData(r.data);
    }).catch(() => setData({ author: null, articles: [] }));
  }, [slug]);

  if (!data) return <div className="max-w-3xl mx-auto px-6 py-24 text-[var(--io-muted)]">Loading…</div>;
  if (!data.author) return <div className="max-w-3xl mx-auto px-6 py-24 text-[var(--io-text)]">Author not found.</div>;

  return (
    <div className="max-w-[1100px] mx-auto px-4 md:px-8 py-14" data-testid="author-page">
      <Seo
        title={`${data.author.name} · ${data.author.role}`}
        description={data.author.bio?.slice(0, 200)}
        path={`/author/${slug}`}
        type="profile"
        jsonLd={[
          ld.person(typeof window !== "undefined" ? window.location.origin : "", { ...data.author, slug }),
          ld.breadcrumb(typeof window !== "undefined" ? window.location.origin : "", [
            { name: "Home", path: "/" },
            { name: data.author.name },
          ]),
        ]}
      />
      <div className="border-b border-[var(--io-border)] pb-8">
        <div className="eyebrow">{data.author.role}</div>
        <h1 className="font-serif text-[44px] md:text-[56px] mt-2 text-[var(--io-text)]">{data.author.name}</h1>
        <p className="mt-4 text-[17px] text-[var(--io-text-2)] max-w-[72ch] leading-relaxed">{data.author.bio}</p>
      </div>

      <h2 className="font-serif text-[24px] md:text-[32px] mt-10 mb-5 text-[var(--io-text)]">Recent articles</h2>
      <div className="divide-y divide-[var(--io-border)]">
        {data.articles.map((a) => (
          <Link key={a.id} to={`/article/${a.slug}`} className="block py-5 group" data-testid={`author-article-${a.slug}`}>
            <div className="font-mono text-[11px] text-[var(--io-muted)]"><span className="text-[var(--io-gold)]">{a.category}</span> · {fmtDate(a.published_at)} · {a.read_minutes || 4} min</div>
            <h3 className="font-serif text-[20px] md:text-[22px] mt-1.5 text-[var(--io-text)] group-hover:text-[var(--io-gold)]">{a.headline}</h3>
            <p className="mt-1.5 text-[14px] text-[var(--io-text-2)] line-clamp-2">{a.summary}</p>
          </Link>
        ))}
        {data.articles.length === 0 && <div className="py-10 text-[var(--io-muted)]">No articles yet.</div>}
      </div>
    </div>
  );
}
